import { render, staticRenderFns } from "./HolidayDetails.vue?vue&type=template&id=566f0789"
import script from "./HolidayDetails.vue?vue&type=script&lang=js"
export * from "./HolidayDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports